import classNames from 'classnames';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import EcoVideo from 'eco-design/base/eco-video';
import React, { useEffect, useRef } from 'react';
import './index.scss';

interface EcoDialogVideoProps {
    /**
     * 是否开启
     */
    open: boolean;
    /**
     * 视频链接
     */
    src: string;
    /**
     * 是否是youtube视频链接
     */
    isYoutube?: boolean;
    /**
     * 关闭回调
     */
    callback?: any;
    /**
     * 样式名
     */
    className?: string;
}

const EcoDialogVideo: React.FC<EcoDialogVideoProps> = ({ open, src, isYoutube = true, className, callback }) => {
    const prefixCls = `eco-dialog-video`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const refDialog = useRef<any>(null);

    useEffect(() => {
        if (open) {
            refDialog.current.showModal();
        }
    }, [open]);

    // 关闭
    const closeHandle = () => {
        refDialog.current.close();
        if (callback) {
            callback();
        }
    };

    return (
        <dialog className={classes} ref={refDialog}>
            <div className={`${prefixCls}-in`}>
                {/* 避免 dialog 标签在浏览器不支持时视频直接出现在页面中心 */}
                {open && (
                    <>
                        {isYoutube && <iframe className={`${prefixCls}-iframe`} src={src}></iframe>}
                        {!isYoutube && <EcoVideo pc={src} className={`${prefixCls}-video`} />}
                    </>
                )}
            </div>
            <button className={`${prefixCls}-close`} onClick={closeHandle}>
                <EcoIconClose />
            </button>
        </dialog>
    );
};

export default EcoDialogVideo;
